import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';
import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId, changelogType, page, pageSize) => {
  const endpoint = URLS.msInventory.changelog(venueId, changelogType, page, pageSize);

  return httpClient.get(endpoint).then(transformV2ClientResponse);
};

export default makeEntityScaffold('SAGA.API.FETCH_MSI_CHANGELOG_BY_TYPE', handler, {
  defaultKey: (_, venueId, changelogType, page) => `${venueId}:${changelogType}:${page}`,
});
